export function userFacingApiError(caught: unknown, fallback: string) {
  const message = caught instanceof Error ? caught.message : "";
  if (
    message === "429" ||
    message.includes("429") ||
    message.includes("RATE_LIMITED") ||
    message === "TOO_MANY_REQUESTS" ||
    message.toLowerCase().includes("too many requests")
  ) {
    return "Too many requests. Please try again later.";
  }
  if (message === "403" || message.includes("FORBIDDEN") || message.includes("PERMISSION_DENIED")) {
    return "You do not have access to this workspace.";
  }
  return fallback;
}
